export const isImage = (url: string) => {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
};
export const isVideo = (url: string) => {
  return /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(url);
};
